<template>
  <div>
    <a
      :href="uploadedCertificateUrl"
      target="_blank"
      class="no-underline my-5 btn btn-secondary btn-size-medium includedIcon"
    >
      <download-icon />View Certificate
    </a>
    <button
      class="my-5 btn btn-secondary danger btn-size-medium includedIcon"
      @click="removeUploadedCertificate"
    >
      <trash-2-icon />Remove Certificate
    </button>
  </div>
</template>

<script>
import store from '@/store/store';
import { DownloadIcon, Trash2Icon } from 'vue-feather-icons';

export default {
  components: {
    DownloadIcon,
    Trash2Icon,
  },
  computed: {
    uploadedCertificateUrl() {
      return store.getters['authStudent/preworkWorkplaceSafety'];
    },
  },
  methods: {
    async removeUploadedCertificate() {
      store.dispatch('authStudent/removeWorkplaceSafetyCertificate');
      const pw_data = {
        status_section: 'section_ws',
        section: 'workplace_safety_url',
        data: null,
        application_type: null,
      };
      store.dispatch('authStudent/completePreworkSection', pw_data);
    },
  },
};
</script>
